import React from "react";
import styled from "styled-components";
import { Colors } from "../../config";
import BizButton from "../../components/BusinessTripComponents/Button";
import walkthrough1 from "../../assets/images/walkthrough/walkthrough_01.png";
import walkthrough2 from "../../assets/images/walkthrough/walkthrough_02.png";
import walkthrough3 from "../../assets/images/walkthrough/walkthrough_03.png";
import walkthrough4 from "../../assets/images/walkthrough/walkthrough_04.png";
import walkthrough5 from "../../assets/images/walkthrough/walkthrough_05.png";
import walkthrough6 from "../../assets/images/walkthrough/walkthrough_06.png";
import walkthrough7 from "../../assets/images/walkthrough/walkthrough_07.png";
import walkthrough8 from "../../assets/images/walkthrough/walkthrough_08.png";
import walkthrough9 from "../../assets/images/walkthrough/walkthrough_09.png";
import walkthrough10 from "../../assets/images/walkthrough/walkthrough_10.jpg";
import walkthrough11 from "../../assets/images/walkthrough/walkthrough_11.png";

import skip from "../../assets/images/skip.png";
import prev from "../../assets/images/prev.png";
import next from "../../assets/images/next.png";

const walkthroughs = [
  { image: walkthrough11, width: "50%" },
  { image: walkthrough9, width: "50%" },
  { image: walkthrough8, width: "50%" },
  { image: walkthrough7, width: "50%" },
  { image: walkthrough6, width: "50%" },
  { image: walkthrough5, width: "50%" },
  { image: walkthrough4, width: "50%" },
  { image: walkthrough3, width: "50%" },
  { image: walkthrough2, width: "50%" },
  { image: walkthrough1, width: "50%" },
  { image: walkthrough10, width: "70%" },
];

const BizTripTutorialOverlay = ({
  onBookBizTripClick,
  onOkClick,
  walkthroughIndex,
  onPrevious,
  onNext,
  onSkip,
}) => {
  const walkthrough = walkthroughs[walkthroughIndex - 1]; // if index starts at 1

  return (
    <Overlay walkthroughIndex={walkthroughIndex}>
      {walkthroughIndex === 0 && (
        <SpotLightContent>
          <div style={{ textAlign: "center", width: "400px" }}>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <div
                style={{
                  background: "white",
                  padding: "4px",
                  borderRadius: "8px",
                  width: "fit-content",
                }}
              >
                <BizButton
                  onClick={() => {}}
                  label="Book Business Trip"
                  color={Colors.prussianBlue}
                />
              </div>
            </div>
            <div
              style={{
                color: "white",
                fontSize: "1.1rem",
                fontWeight: "600",
                margin: "1rem 0",
              }}
            >
              <div>All your business travel, in one place. </div>
              <div>
                Request Business Trip leave, per diem, and end-to-end travel
                bookings with Joury Travels, including flights, hotels, visas,
                and car rentals, through PowerFly’s single, integrated platform.
              </div>
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "0.5rem",
                justifyContent: "center",
              }}
            >
              <BizButton
                isRounded
                label="Learn to use"
                color={Colors.red}
                width="160px"
                onClick={onBookBizTripClick}
              />
              {/* <BizButton
                isRounded
                label="Ok"
                color={Colors.red}
                width="160px"
                onClick={onOkClick}
              /> */}
            </div>
          </div>
        </SpotLightContent>
      )}
      {walkthroughIndex > 0 && (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            paddingRight: "1rem",
            paddingLeft: "1rem",
          }}
        >
          <div
            style={{
              height: "5rem",
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
            }}
          >
            <div
              style={{
                display: "flex",
                gap: "1rem",
                justifyContent: "center",
              }}
            >
              {/* <BizButton
                isRounded
                label="Skip"
                color={Colors.brandTwo}
                width="100px"
                onClick={onSkip}
                postfixIcon={
                  <img
                    src={skip}
                    style={{ width: "24px", marginLeft: "4px" }}
                  />
                }
              /> */}
            </div>
          </div>
          <div
            style={{
              // flex: 1,
              display: "flex",
              justifyContent: "center",
              height: "calc(100vh - 10rem)",
            }}
          >
            <div
              style={{
                display: "flex",
                gap: "1rem",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {walkthrough && (
                <WalkthroughImage
                  src={walkthrough.image}
                  $width={walkthrough.width}
                  alt={`walkthrough ${walkthroughIndex}`}
                />
              )}
            </div>
          </div>
          <div
            style={{
              height: "5rem",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div
              style={{
                display: "flex",
                gap: "1rem",
                justifyContent: "center",
              }}
            >
              <BizButton
                isRounded
                label="Prev"
                color={Colors.white}
                width="100px"
                fontColor={Colors.brandOne}
                disabled={walkthroughIndex === 1}
                onClick={onPrevious}
                prefixIcon={
                  <img
                    src={prev}
                    style={{ width: "24px", marginRight: "4px" }}
                  />
                }
              />
              <BizButton
                isRounded
                label={walkthroughIndex === 11 ? "Done" : "Next"}
                color={Colors.white}
                width="100px"
                fontColor={Colors.brandOne}
                postfixIcon={
                  <img
                    src={next}
                    style={{ width: "20px", marginLeft: "6px" }}
                  />
                }
                // disabled={walkthroughIndex === 10}
                onClick={onNext}
              />
            </div>
          </div>
        </div>
      )}
    </Overlay>
  );
};

const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  background: ${(props) =>
    props.walkthroughIndex === 0
      ? Colors.shark + "99"
      : Colors.brandOne + "99"};
  height: 100vh;
  width: 100vw;
  z-index: 10;
  backdrop-filter: ${(props) =>
    props.walkthroughIndex === 0 ? "blur(0px)" : "blur(16px)"};
`;

const SpotLightContent = styled.div`
  position: absolute;
  top: 380px;
  left: 0;
  width: 100%;
  z-index: 7;
  display: flex;
  justify-content: center;
`;

const WalkthroughImage = styled.img`
  width: ${({ $width }) => $width};

  @media (max-width: 1178px) {
    width: 100%;
  }
`;

export default BizTripTutorialOverlay;
